export function getAppUrl () {
  const { protocol, hostname } = window.location

  // Electron production builds load the renderer from file://, so window.location
  // is unusable as an origin. Fall back to the build-time API_URL.
  if (protocol === 'file:') {
    return process.env.API_URL
  }

  if (hostname.startsWith('talk.')) {
    return `${protocol}//` + hostname.replace(/^talk\./, 'app.')
  }

  return `${protocol}//${hostname}`
}

export default {
  methods: {
    getCampaignURL (campaignId) {
      return getAppUrl() + `/lines/${campaignId}/settings`
    },

    getCampaignActivityURL (campaignId) {
      return getAppUrl() + `/lines/${campaignId}/activity`
    },

    getRingGroupURL (ringGroupId) {
      return getAppUrl() + `/ring-groups/dialog/${ringGroupId}`
    },

    getUserURL (userId) {
      return getAppUrl() + `/users/dialog/${userId}`
    },

    getUserActivityURL (userId) {
      return getAppUrl() + `/users/${userId}/activity`
    },

    getWorkflowURL (workflowId) {
      return getAppUrl() + `/sequences2/manager/${workflowId}`
    },

    getFlowURL (flowId) {
      return getAppUrl() + `/flows/${flowId}`
    },

    getBroadcastSettingURL () {
      return getAppUrl() + '/account?tab=settings#broadcasts_business_hours'
    },

    getComplianceURL () {
      return getAppUrl() + '/account?tab=compliance'
    },

    getInternationalPricingURL () {
      return getAppUrl() + '/account?tab=international_pricing'
    },

    getClassicURL () {
      return getAppUrl()
    }
  }
}
